import { useAppDispatch, useAppSelector } from 'app/hooks';
import Breadcrumb from 'components/Breadcrumb';
import Loading from 'components/Loading';
import Paths from 'helper/paths';
import { useQueryParams } from 'hooks/useQueryParams';
import WithSidebar from 'layouts/WithSidebar';
import BreadcrumbInterface from 'models/breadcrumb/breadcrumb.interface';
import FlightFormInterface, { checkInstanceOfFlightForm } from 'models/flight/flightForm.interface';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getDeparturAirportService } from 'services/publicData.service';
import {
  changeFlightBookSteps,
  flightActiveBookStep,
  formDataToQuery,
  setFirstFlightBookStepTitle,
  setForm,
  updateComplementaryForm,
} from 'store/flight/flightSlice';
import { setDepartureError, setDepartureLoading, setDepartureLocationsRoute } from 'store/publicData/publicDataSlice';
import * as S from './FlightBook.styles';
import FlightSteps from './components/flightSteps';
import FlightList from './flightList';
import FlightBookPassengers from './flightPassengers';

const DiscountBook = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const query = useQueryParams();

  const activeStep = useAppSelector(flightActiveBookStep);
  const departure = searchParams.get('departure');
  const destination = searchParams.get('destination');
  const discountTicketId = searchParams.get('discountTicketId');
  const [loading, setLoading] = useState<boolean>(true);
  const formDataQueryState = useAppSelector(formDataToQuery);

  const breadcrumbLinks = [
    {
      title: t(`pageTitles.${Paths.Dashboard.index().name}`),
      url: Paths.Dashboard.index().route,
      active: true,
    },
    {
      title: t(`pageTitles.${Paths.Services.index().name}`),
      url: Paths.Services.index().route,
      active: false,
    },
    {
      // title: t(`pageTitles.${Paths.Services.awardTicketBook().name}`),
      url: '',
      active: false,
    },
  ] as BreadcrumbInterface[];

  const setFlightFormState = async () => {
    const flightFormObject = {} as FlightFormInterface;
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      if (checkInstanceOfFlightForm(param)) flightFormObject[param] = value;
    }
    await dispatch(setForm(flightFormObject));
    return flightFormObject;
  };

  const getAirportNames = async () => {
    dispatch(setDepartureLoading());

    getDeparturAirportService()
      .then((res) => {
        dispatch(setDepartureLocationsRoute(res.data));

        const foundedDeparture = res.data.find((e) => e.code === departure);
        if (foundedDeparture) {
          dispatch(updateComplementaryForm({ key: 'departureText', value: foundedDeparture.name }));
          dispatch(updateComplementaryForm({ key: 'departureCountryCode', value: foundedDeparture.countryCode }));
        }

        const foundedDestination = res.data.find((e) => e.code === destination);
        if (foundedDestination) {
          dispatch(updateComplementaryForm({ key: 'destinationText', value: foundedDestination.name }));
          dispatch(updateComplementaryForm({ key: 'destinationCountryCode', value: foundedDestination.countryCode }));
        }
      })
      .catch((ex) => {
        dispatch(setDepartureError(ex));
      });
  };

  useEffect(() => {
    setLoading(true);
    if (!departure || !destination) {
      toast.error(t('errors.fillAllFields'));
      // navigate(Paths.Services.awardTicket().route + '?' + formDataQueryState);
    }
    dispatch(changeFlightBookSteps(parseInt(query.get('step') || '0')));
    dispatch(setFirstFlightBookStepTitle(`${departure} -> ${destination}`));

    Promise.all([setFlightFormState(), getAirportNames()])
      .then((res) => {})
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <S.WithSidebar as={WithSidebar}>
      <Breadcrumb links={breadcrumbLinks} />
      <S.StepWrapper>
        <FlightSteps />
      </S.StepWrapper>
      <S.Body>
        {loading ? (
          <Loading />
        ) : activeStep === 0 ? (
          <FlightList discountTicketId={discountTicketId} />
        ) : activeStep === 1 ? (
          <FlightBookPassengers discountTicketId={discountTicketId} />
        ) : null}
      </S.Body>
    </S.WithSidebar>
  );
};
export default DiscountBook;
